import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ImageCropperComponent } from "ngx-image-cropper";
import { FileGalleryDialogComponent } from "./file-gallery-dialog.component";
import { ImageEditComponent } from "./image-edit.component";
import { ImageHandlerComponent } from "./image-handler.component";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { GalleriaModule } from "primeng/galleria";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GalleriaModule,
    ImageCropperComponent,
    ButtonModule,
    CheckboxModule
  ],
  declarations: [
    FileGalleryDialogComponent,
    ImageEditComponent,
    ImageHandlerComponent,
  ],
  exports: [
    FileGalleryDialogComponent,
    ImageEditComponent,
    ImageHandlerComponent,
  ]
})
export class ImageModule {

}